import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Checkbox,
  Button,
  Tag,
  Space,
  Divider,
  message,
} from "antd";
import { SettingTwoTone } from "@ant-design/icons";
import { UserService } from "../../Services/Manage/UserService";
import { PermissionService } from "../../Services/Permission/PermissionService";
import useMessage from "antd/es/message/useMessage";

const Permissions = ({ selectedUsers }) => {
  const [message, msgContx] = useMessage();
  const [hasExistingPermission, setHasExistingPermission] = useState(false);
  const [updateDataId, setDataUpdateId] = useState([]);

  const initialData = {
    Workspace: [
         {
        module: "DashBoard",
        link:'/dashboard',
        add: true,
        edit: true,
        delete: true,
        read: true,
      },

       {
        module: "Manage Services",
        link:'/manage-services',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },

      {
        module: "Enquiry",
        link:'/enquiry',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      {
        module: "Quotation",
        link:'/quotation',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      {
        module: "Invoice",
        link:'/invoice',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      {
        module: "Project",
        link:'/projects',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
    ],
    HRManagement:[
      
      {
        module: "Work Force Management",
        link:'/workforce-management',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      {
        module: "Permission",
        link:'/manage-permission',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
       {
        module: "Employees",
        link:'/manage-employees',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      {
        module: "Leave Request",
        link:'/leave-request',
        add: true,
        edit: true,
        delete: true,
        read: true,
      },
    ],

    TaskManagement:[
   
      {
        module: "Manage Project and Task",
        link:'/manage-task',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
    
       {
        module: "Project TimeLine",
        link:'/project-timeline',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },

          {
        module: "Assigned Task",
        link:'/assigned-task',
        add: true,
        edit: true,
        delete: true,
        read: true,
      },
         {
        module: "My Task",
        link:'/my-task',
        add: true,
        edit: true,
        delete: true,
        read: true,
      },

    ],
    Finance: [
     
      {
        module: "Vendors",
        link:'/manage-vendor',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      {
        module: "Manage Purchase Order",
        link:'/purchase-order',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      {
        module: "Manage Project Expenses",
        link:'/project-expenses',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      {
        module: "Manage Utility Bills",
        link:'/utility-bills',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      {
        module: "P & L Report",
        link:'/finance/reports/p-l',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      {
        module: "Pay Mode Vise Report",
        link:'/finance/reports/pay-mode-vise',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
    ],
    Others: [
     
      // {
      //   module: "Expenses",
      //   link:'/manage-expense',
      //   add: false,
      //   edit: false,
      //   delete: false,
      //   read: false,
      // },
      // {
      //   module: "Vendors",
      //   link:'/manage-vendor',
      //   add: false,
      //   edit: false,
      //   delete: false,
      //   read: false,
      // },
   
     
      {
        module: "Bank Details",
        link:'/manage-bank-data',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      {
        module: "Letter Header & others",
        link:'/manage-letter-formats',
        add: false,
        edit: false,
        delete: false,
        read: false,
      },
      
    ],
  };

  useEffect(() => {
    if (selectedUsers?.length > 0 && selectedUsers[0]?.user_id) {
      const fetchPermissions = async () => {
        try {
          const userId = selectedUsers[0].user_id;
          const response = await PermissionService.getPermissionDetailsById(
            userId
          );
          // console.log("Fetched permissions:", response);

          if (response?.status && response?.data?.permissions) {
            const parsedPermissions = JSON.parse(response.data.permissions);

            setDataUpdateId(response?.data);

            const updatedData = { ...initialData };

            Object.keys(updatedData).forEach((category) => {
              updatedData[category] = updatedData[category].map((item) => {
                const match = parsedPermissions.find(
                  (p) => p.link === item.link
                );
                return match ? { ...item, ...match } : item;
              });
            });

            const initialized = initializeDataWithKeys(updatedData);
            setDataSource(initialized);
            setHasExistingPermission(true);
          } else {
            setDataSource(initializeDataWithKeys(initialData));
            setHasExistingPermission(false);
          }
        } catch (error) {
          console.error("Error fetching permissions:", error);
          message.error("Failed to fetch user permissions.");
          setDataSource(initializeDataWithKeys(initialData));
          setHasExistingPermission(false);
        }
      };

      fetchPermissions();
    }
  }, [selectedUsers]);

  const initializeDataWithKeys = (data) =>
    Object.fromEntries(
      Object.entries(data).map(([category, items]) => [
        category,
        items.map((item, index) => ({ ...item, key: `${category}-${index}` })),
      ])
    );

  const [dataSource, setDataSource] = useState(
    initializeDataWithKeys(initialData)
  );

  const handleCheckboxChange = (category, recordKey, field, checked) => {
    setDataSource((prev) => ({
      ...prev,
      [category]: prev[category].map((row) => {
        if (row.key === recordKey) {
          const updatedRow = {
            ...row,
            [field]: checked,
          };

          // Auto-check read if add, edit, or delete is checked
          if (field !== "read" && checked) {
            updatedRow.read = true;
          }
          // Auto-uncheck read if all other permissions are unchecked
          else if (field !== "read" && !checked) {
            const hasOtherPermissions =
              (field === "add" ? false : row.add) ||
              (field === "edit" ? false : row.edit) ||
              (field === "delete" ? false : row.delete);

            if (!hasOtherPermissions) {
              updatedRow.read = false;
            }
          }
          // If read is manually unchecked, keep it unchecked
          else if (field === "read" && !checked) {
            updatedRow.read = false;
          }

          return updatedRow;
        }
        return row;
      }),
    }));
  };

  const handleSelectAll = (category, field, checked) => {
    setDataSource((prev) => ({
      ...prev,
      [category]: prev[category].map((row) => {
        const updatedRow = {
          ...row,
          [field]: checked,
        };

        // Auto-check read for all rows if add, edit, or delete is selected
        if (field !== "read" && checked) {
          updatedRow.read = true;
        }
        // Auto-uncheck read for all rows if all other permissions are being unchecked
        else if (field !== "read" && !checked) {
          const hasOtherPermissions =
            (field === "add" ? false : row.add) ||
            (field === "edit" ? false : row.edit) ||
            (field === "delete" ? false : row.delete);

          if (!hasOtherPermissions) {
            updatedRow.read = false;
          }
        }

        return updatedRow;
      }),
    }));
  };

  const counts = Object.values(dataSource)
    .flat()
    .reduce(
      (acc, row) => ({
        add: acc.add + (row.add ? 1 : 0),
        edit: acc.edit + (row.edit ? 1 : 0),
        delete: acc.delete + (row.delete ? 1 : 0),
        read: acc.read + (row.read ? 1 : 0),
      }),
      { add: 0, edit: 0, delete: 0, read: 0 }
    );

  const handleGrantPermission = async () => {
    const mergedArray = Object.values(dataSource)
      .flat()
      .map(({ key, ...rest }) => rest);

    const user = await UserService.getOmeUser();

    

    const data_post = {
      permissions: JSON.stringify(mergedArray),
      permitted_by: user.uid,
      user_id: selectedUsers[0].user_id,
    };

    try {
      const req = await PermissionService.createPermission(data_post);
      // console.log(req);

      if (req.status) {
        message.success(req.message);
      } else {
        message.error(req.message);
      }
    } catch (error) {}
    console.log(data_post);
  };

  const handleUpdatePermission = async () => {
    try {
      const mergedArray = Object.values(dataSource)
        .flat()
        .map(({ key, ...rest }) => rest);

      const user = await UserService.getOmeUser();

      console.log(mergedArray);

      const data_post = {
        permissions: JSON.stringify(mergedArray),
        permitted_by: user.uid,
        user_id: selectedUsers[0].user_id,
      };

      const req = await PermissionService.updatePermission(
        data_post,
        updateDataId.id
      );
      // console.log(req);

      if (req.status) {
        message.success(req.message);
      } else {
        message.error(req.message);
      }

      // console.log("updated permission", data_post);
    } catch (error) {
      console.error(error);
    }
  };

  const columns = [
    {
      title: "Module",
      dataIndex: "module",
      key: "module",
      render: (text) => <strong>{text}</strong>,
    },
    ...["add", "edit", "delete", "read"].map((field) => ({
      title: (category) => (
        <Checkbox
          checked={dataSource[category].every((row) => row[field])}
          indeterminate={
            dataSource[category].some((row) => row[field]) &&
            !dataSource[category].every((row) => row[field])
          }
          onChange={(e) => handleSelectAll(category, field, e.target.checked)}
        >
          <span style={{ marginLeft: 10 }}>
            {field.charAt(0).toUpperCase() + field.slice(1)}
          </span>
        </Checkbox>
      ),
      align: "center",
      dataIndex: field,
      key: field,
      render: (value, record, _, category) => (
        <Checkbox
          checked={value}
          onChange={(e) =>
            handleCheckboxChange(category, record.key, field, e.target.checked)
          }
        />
      ),
    })),
  ];

  const generateColumns = (category) =>
    columns.map((col) => ({
      ...col,
      title:
        typeof col.title === "function" ? () => col.title(category) : col.title,
      render: (text, record, index) =>
        col.render(text, record, index, category),
    }));

  const styles = {
    tags: { fontSize: "15px", padding: "4px 10px" },
    card: { margin: "16px 0" },
    tableTitle: {
      display: "flex",
      alignItems: "center",
      fontSize: 16,
      fontWeight: "bold",
    },
  };

  return (
    <>
      {msgContx}

      <Card
        title="Permission Matrix"
        extra={
          <Space>
            {[
              { label: "Add", value: counts.add, color: "blue" },
              { label: "Edit", value: counts.edit, color: "cyan" },
              { label: "Delete", value: counts.delete, color: "red" },
              { label: "Read", value: counts.read, color: "purple" },
            ].map(({ label, value, color }) => (
              <Tag key={label} color={color} style={styles.tags}>
                {label}: {value}
              </Tag>
            ))}
          </Space>
        }
        style={styles.card}
      >
        <Space direction="vertical" size="small" style={{ width: "100%" }}>
          {Object.entries(dataSource).map(([category, data]) => (
            <Table
              key={category}
              columns={generateColumns(category)}
              dataSource={data}
              pagination={false}
              
              title={() => (
                <div style={styles.tableTitle}>
                  <SettingTwoTone style={{ marginRight: 8, fontSize: 18 }} />
                  {category}
                </div>
              )}
            />
          ))}
        </Space>
        <Divider />
        <div style={{ textAlign: "right", marginTop: 16, marginBottom: 20 }}>
          <Button
            size="large"
            type="primary"
            onClick={
              hasExistingPermission
                ? handleUpdatePermission
                : handleGrantPermission
            }
          >
            {hasExistingPermission ? "Update Permission" : "Grant Permission"}
          </Button>
        </div>
      </Card>
    </>
  );
};

export default Permissions;
